import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BreadcrumbDropdownContext = /*#__PURE__*/createContext({
  isInDropdown: false
});
export const BreadcrumbDropdownContextProvider = _ref => {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(BreadcrumbDropdownContext.Provider, {
    value: props,
    children: children
  });
};
export const useBreadcrumbDropdownContext = () => {
  return useContext(BreadcrumbDropdownContext);
};